(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    // Update the waist note the moment a size is tapped; the section refresh that
  // follows renders the same text on the server.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.dataset.sizeNote === undefined) return;
    const output = input.closest('variant-picker')?.querySelector('[data-size-note-output]');
    if (output) output.textContent = input.dataset.sizeNote;
  });
  } catch(e) { console.error(e); }
})();

})();
